export const InitialRatingData = {
  payload: {
    name: "",
    email: "",
    subject: "",
    body: "",
    isDownload: false,
  },
};
